<template>
  <div v-if="current">
    
    <v-card width="100%">
      <v-card-title>Dados do registro</v-card-title>
      <v-card-text>
        <v-form>
          <div class="row">
            <div class="col-md-12 col-sm-1">
              <v-text-field
                label="Nome"
                v-model="current.name"
                outlined
                dense
                disabled
              ></v-text-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 col-sm-1">
              <v-textarea
                label="Observação"
                v-model="current.obs"
                outlined
                dense
                disabled
              ></v-textarea>
            </div>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" @click="dialogName()">Alternar nome</v-btn>
        <v-btn color="primary" @click="dialogObs()">Alternar observação</v-btn>
        <v-btn color="warning" @click="routes()">Rotas</v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="dialog_name" max-width="500px">
      <v-card>
        <v-card-title>Alterar Nome</v-card-title>
        <v-card-text>
          <div class="col-md-12 col-sm-1">
            <v-text-field
              label="Nome"
              v-model="changed.name"
              outlined
              dense
            ></v-text-field>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="putName()">Salvar</v-btn>
          <v-btn color="default" @click="dialog_name = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_obs" max-width="500px">
      <v-card>
        <v-card-title>Alterar Observação</v-card-title>
        <v-card-text>
          <div class="col-md-12 col-sm-1">
            <v-textarea
              label="Observação"
              v-model="changed.obs"
              outlined
              dense
            ></v-textarea>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="putObs()">Salvar</v-btn>
          <v-btn color="default" @click="dialog_obs = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-dialog v-model="dialog_loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Por favor aguarde
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import api from "../../api/index.js";
import router from '../../router/index.js';
export default {
  data: () => ({
    current: null,
    changed: {},
    dialog_loading: false,
    dialog_name: false,
    dialog_obs: false
  }),
  created: function () {
    this.load();
  },
  methods: {
    load: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .get("/plan/" + this.$route.params.id, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao recuperar registro!");
          console.log(error);
        });
    },
    dialogName: function(){
      this.changed.name = this.current.name;
      this.dialog_name = true;
    },
    putName: function(){
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .put("/plan/name/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_name = false;
          alert("Nome alterado com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao alterar nome!");
          console.log(error);
        });
    },
    dialogObs: function(){
      this.changed.obs = this.current.obs;
      this.dialog_obs = true;
    },
    putObs: function(){
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .put("/plan/obs/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_obs = false;
          alert("Observação alterada com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao alterar observação!");
          console.log(error);
        });
    },
    routes: function(){
      router.push({path: "/plan/"+this.$route.params.id+"/routes"});
    }
  }
};
</script>